import { render, staticRenderFns } from "./DeliveryBookingDetail.vue?vue&type=template&id=d04d37ee"
import script from "./DeliveryBookingDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryBookingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports